import request from '@/utils/request'


// 查询会员配置列表
export function listMemberConfig(query) {
  return request({
    url: '/memberConfig/memberConfig/list',
    method: 'get',
    params: query
  })
}

// 查询会员配置分页
export function pageMemberConfig(query) {
  return request({
    url: '/memberConfig/memberConfig/page',
    method: 'get',
    params: query
  })
}

// 查询会员配置详细
export function getMemberConfig(data) {
  return request({
    url: '/memberConfig/memberConfig/detail',
    method: 'get',
    params: data
  })
}

// 新增会员配置
export function addMemberConfig(data) {
  return request({
    url: '/memberConfig/memberConfig/add',
    method: 'post',
    data: data
  })
}

// 修改会员配置
export function updateMemberConfig(data) {
  return request({
    url: '/memberConfig/memberConfig/edit',
    method: 'post',
    data: data
  })
}

// 删除会员配置
export function delMemberConfig(data) {
  return request({
    url: '/memberConfig/memberConfig/delete',
    method: 'post',
    data: data
  })
}
